import React from "react"
import styled from "styled-components"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"
import GoogleLogin from "react-google-login"

import {
  H1,
  H2,
  P,
  Input,
  NextStep,
  PrevNextStep,
  PrimaryAnchor,
  InputSVGContainer,
} from "../general/GeneralStyles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const FormH2 = styled(H2)`
  margin: 21px 0;
`

const FormGrid = styled.div`
  width: 95%;
  max-width: 550px;

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
  }

  > div span {
    margin-left: 10px;
    margin-right: 10px;
    color: ${props => props.theme.primaryTextColor};
    font-family: ${props => props.theme.secondaryFont};
    font-size: 14px;
    line-height: 15px;
  }

  hr {
    flex-grow: 1;
    margin-bottom: 0;
  }

  label {
    width: 80%;
    display: inline-block;
  }

  ${P} {
    display: inline-block;
    margin-bottom: 0;
  }
`

const Button = styled.button`
  width: 100%;
  margin-bottom: 12px;
  padding: 9px 0;
  border: none;
  cursor: pointer;
  color: white;

  font-family: ${props => props.theme.primaryFont};
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
`

const FBButton = styled(Button)`
  background: #3a5998;
`

const GoogleButton = styled(Button)`
  background: #dd4b39;
  margin-bottom: 22px;
`

const Step3 = props => {
  const responseFacebook = resp => {
    /* TODO: not sure if I should be using id as password */
    console.log(resp)

    props.setFormData({
      ...props.formData,
      ...resp,
      email: resp.email,
      password: resp.id,
      password_confirmation: resp.id,
    })
    props.setStep(4)
  }

  const responseGoogle = resp => {
    console.log(resp)
    props.setFormData({
      ...props.formData,
      ...resp,
      email: resp.profileObj.email,
      password: resp.googleId,
      password_confirmation: resp.googleId,
    })
    props.setStep(4)
  }

  const inputValidation = () => {
    if (!props.formData.email || !props.formData.password) {
      alert("Please fill all the fields to continue")
    } else {
      console.log("Step 3 props.formData: " + props.formData)
      props.setStep(4)
    }
  }

  return (
    <>
      <H1>Sign Up</H1>
      <FormH2>
        <span>Step 3:</span> Login Information
      </FormH2>
      <FormGrid>
        {/* TODO: abstract out these packages or not 🤷🏻‍ */}
        {/* <FacebookLogin
          appId="1155910611184068"
          fields="name,email"
          callback={responseFacebook}
          render={renderProps => (
            <FBButton onClick={renderProps.onClick}>
              <FontAwesomeIcon icon={["fab", "facebook-f"]} /> &nbsp; Sign Up
              with Facebook
            </FBButton>
          )}
        /> */}
        <GoogleLogin
          clientId="166238523338-3vbbqdnga5v5vf1vism2fnp6u0r59gq3.apps.googleusercontent.com"
          onSuccess={responseGoogle}
          onFailure={responseGoogle}
          render={renderProps => (
            <GoogleButton
              onClick={renderProps.onClick}
              disabled={renderProps.disabled}
            >
              <FontAwesomeIcon icon="google-plus-g" />
              <FontAwesomeIcon icon={["fab", "google-plus-g"]} /> &nbsp; Sign Up
              with Google
            </GoogleButton>
          )}
        />
        <div>
          <hr />
          <span>Or</span>
          <hr />
        </div>
        <InputSVGContainer>
          <FontAwesomeIcon icon="envelope" />
          <Input
            type="email"
            placeholder="Email Address"
            name="email"
            value={props.formData.email}
            onChange={props.inputHandler}
            required
          />
        </InputSVGContainer>
        <InputSVGContainer>
          <FontAwesomeIcon icon="lock" />
          <Input
            type="password"
            placeholder="Password"
            name="password"
            value={props.formData.password}
            onChange={props.inputHandler}
            required
          />
        </InputSVGContainer>
        <InputSVGContainer>
          <FontAwesomeIcon icon="lock" />
          <Input
            type="password"
            placeholder="Password Confirmation"
            name="password_confirmation"
            value={props.formData.password_confirmation}
            onChange={props.inputHandler}
            required
          />
        </InputSVGContainer>
        <PrevNextStep>
          <PrimaryAnchor href="#" onClick={() => props.setStep(2)}>
            {"<"} &nbsp;&nbsp; Previous Step
          </PrimaryAnchor>
          <NextStep href="#" onClick={inputValidation}>
            Next Step
          </NextStep>
        </PrevNextStep>
      </FormGrid>
    </>
  )
}

export default Step3
